export default __webpack_public_path__ + "static/media/virgool_large.90b81d78.svg";